// extracted by mini-css-extract-plugin
module.exports = {"QuizList":"kvD_d1Rf0etHnKYfQptXR"};